// extracted by mini-css-extract-plugin
export default {"modalorder":"OrderDetails_modalorder__2upkV","number":"OrderDetails_number__9I+5W"};